import React from 'react';

const SourdoughStarterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Jar Lid */}
    <line x1="6" y1="4" x2="18" y2="4" />
    {/* Jar Body */}
    <rect x="6" y="6" width="12" height="14" rx="2" ry="2" />
    {/* Starter Content */}
    
  </svg>
);

export default SourdoughStarterIcon;
